<!-- Our Vision & Mission Section -->
<section
  class="py-24 bg-white border-t border-slate-200/60"
  aria-labelledby="vision-heading"
>
  <div class="container mx-auto px-6">
    <!-- Section Header -->
    <div class="text-center max-w-3xl mx-auto mb-16 space-y-4">
      <div
        class="inline-flex items-center gap-2 bg-teal-100 text-teal-800 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider"
      >
        <i class="fa-solid fa-bullseye"></i>
        <span>Our Mission & Vision</span>
      </div>
      <h2
        id="vision-heading"
        class="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight"
      >
        Transforming Education in Sri Lanka
      </h2>
      <p class="text-lg text-slate-600 leading-relaxed">
        Empowering every Sri Lankan student with equal access to top-tier teaching, interactive technology, and affordable learning resources.
      </p>
    </div>

    <!-- Vision Cards Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
      
      <!-- Card 1 -->
      <div
        class="daisy-card bg-slate-50/80 border border-slate-200/80 p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300"
      >
        <div
          class="w-14 h-14 bg-blue-100 text-blue-600 rounded-2xl flex items-center justify-center text-2xl font-bold mb-6"
        >
          <i class="fa-solid fa-award"></i>
        </div>
        <h3 class="text-xl font-bold text-slate-900 mb-2">
          Highest Academic Standards
        </h3>
        <p class="text-slate-600 text-sm leading-relaxed">
          Delivering rich, curriculum-aligned lesson modules designed specifically to meet National O/L, A/L, and Edexcel evaluation standards.
        </p>
      </div>

      <!-- Card 2 -->
      <div
        class="daisy-card bg-slate-50/80 border border-slate-200/80 p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300"
      >
        <div
          class="w-14 h-14 bg-purple-100 text-purple-600 rounded-2xl flex items-center justify-center text-2xl font-bold mb-6"
        >
          <i class="fa-solid fa-users"></i>
        </div>
        <h3 class="text-xl font-bold text-slate-900 mb-2">
          Inclusive Student Community
        </h3>
        <p class="text-slate-600 text-sm leading-relaxed">
          Building a supportive learning community where students from all regions of Sri Lanka can connect, collaborate, and grow together.
        </p>
      </div>

      <!-- Card 3 -->
      <div
        class="daisy-card bg-slate-50/80 border border-slate-200/80 p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300"
      >
        <div
          class="w-14 h-14 bg-emerald-100 text-emerald-600 rounded-2xl flex items-center justify-center text-2xl font-bold mb-6"
        >
          <i class="fa-solid fa-lightbulb"></i>
        </div>
        <h3 class="text-xl font-bold text-slate-900 mb-2">
          Innovative Technology
        </h3>
        <p class="text-slate-600 text-sm leading-relaxed">
          Leveraging seamless Zoom streaming, real-time analytics, and instant material distribution to deliver seamless digital education.
        </p>
      </div>

    </div>

    <!-- Core Pillars Highlight Box -->
    <div
      class="daisy-card bg-slate-50 border border-slate-200/80 p-8 sm:p-12 rounded-3xl text-center max-w-4xl mx-auto shadow-sm space-y-4"
    >
      <h3 class="text-2xl sm:text-3xl font-extrabold text-slate-900">
        Building Tomorrow's Leaders
      </h3>
      <p class="text-slate-600 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
        We believe that quality education should know no geographical or economic boundaries. Our platform is designed to make learning engaging, accessible, and impactful.
      </p>

      <div class="flex flex-wrap items-center justify-center gap-6 text-sm text-slate-700 pt-2">
        <div class="flex items-center gap-2">
          <i class="fa-solid fa-circle-check text-emerald-600"></i>
          <span>Expert Curriculum Design</span>
        </div>
        <div class="flex items-center gap-2">
          <i class="fa-solid fa-circle-check text-emerald-600"></i>
          <span>Live Interactive Zoom Classes</span>
        </div>
        <div class="flex items-center gap-2">
          <i class="fa-solid fa-circle-check text-emerald-600"></i>
          <span>Student-Centered Experience</span>
        </div>
      </div>
    </div>

  </div>
</section>
